import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicElement, SearchComponent } from '@sirius/common';
import { BehaviorSubject } from 'rxjs';

// Define the config interface

interface MarketplaceSearchConfig {
    id: string;
    componentName: string;
    storyblokEditable: null;
}

@Component({
    selector: 'commerce-marketplace-search',
    templateUrl: './marketplace-search.component.html',
    styleUrls: ['./marketplace-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SearchComponent]
})
export class MarketplaceSearchComponent implements DynamicElement {
    private _router = inject(Router);

    @Input() config!: MarketplaceSearchConfig;

    searchQuery = '';
    fetching$ = new BehaviorSubject<boolean>(false);


    onSearch(query: string): void {
        if (query) {
            this.fetching$.next(true);
            this._router
                .navigate(['/marketplace/products'], {
                    queryParams: { search: query.trim() },
                })
                .finally(() => {
                    this.fetching$.next(false);
                });
        }
    }
}
